import { RHFTextField } from './rhf-text-field';
import { RHFTextareaField } from './rhf-textarea-field';

export const Field = {
  Text: RHFTextField,
  Textarea: RHFTextareaField,
};
